import React from 'react';
import {Result} from 'antd-mobile';
import { useHistory } from 'react-router-dom';

const AccessDenied = () => {
    const history = useHistory();

    return (
        <Result
            imgUrl={require('../../../images/fff.png')}
            title='Accès refusé'
            message='Tu as été deconnecté'
            className='ls_no-result'
            buttonText='se connecter'
            buttonType='ghost'
            onButtonClick={() => history.push('/connexion')}
        />
    );
}

export default AccessDenied;